export const isHashLink = (href: string): boolean => {
  return new RegExp(/^#/).test(href)
}
